export enum AssortmentTypeDTO {
  BASE = 'BASE',
  DRAFT = 'DRAFT',
  MONITORING = 'MONITORING',
}

export type OrgUnitTypeDTO = 'BRAND' | 'DATAOWNER' | 'LOCATION';

export interface AssortmentOrgUnitDTO {
  type: OrgUnitTypeDTO;
  id: number;
  name: string;
}

export type AssortmentDTO = {
  id: number;
  title: string;
  type: AssortmentTypeDTO;
  owner?: AssortmentOrgUnitDTO;
  size: number;
};
